// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_homepage_footer_app__2OkF7"};